
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Luciole'
  },
  buttonSettingIcon: {
    backgroundColor: '#F2F2F2',
    backgroundActiveColor: '#ED7F15',
    contrastText: '#000000',
    contrastTextActive: '#000000',
    contrastTextSettings: '#172370',
    backgroundSettingActive: ''
  },
  cardRoadStep: {
    backgroundColor: '#FFFFFF',
    backgroundActiveColor: 'rgba(237, 127, 21, 0.2)',
    borderCard: '#CACFD2',
    borderCardActive: '#172370'
  },
  select: {
    main: '#FFFFFF',
    backgroundIcon: '#172370',
    icon: '#FFFFFF'
  },
  inputLabel: {
    color: '#D5DBFF',
    text: '#D5DBFF'
  },
  iconMenuItem: {
    background: '#ED7F15',
    backgroundActive: '#FFFFFF',
    border: '#FFFFFF',
    icon: '#FFFFFF',
    iconActive: '#ED7F15',
    iconBackground: 'transparent'
  },
  textMenuItem: {
    background: '#ED7F15',
    backgroundActive: '#FFFFFF',
    color: '#FFFFFF',
    colorActive: '#ED7F15'
  },
  buttonItinFeature: {
    background: '#ED7F15',
    backgroundHover: '#767676',
    color: '#172370',
    colorHover: '#FFFFFF'
  },
  buttonSwitch: {
    backgroundActiveColor: '#219653',
    activeThumbColor: '#FFFFFF',
    backgroundColor: '#FFFFFF',
    thumbColor: '#219653'
  },
  accessibilityItems: {
    colorLabel: '#000000',
  },
  palette: {
    common: {
      hover: '#797676',
      texthover: '#FFFFFF'
    },
    primary: {
      main: '#ED7F15',
      contrastText: '#000000',
      contrastBackground: '#FFFFFF',
      contrastBorder: '#FFFFFF'
    },
    contrastprimary: {
      main: '#FFFFFF',
      contrastText: '#ED7F15',
    },
    secondary: {
      main: '#F3AC67',
      contrastText: '#FFFFFF',
    },
    modal: {
      main: 'ED7F15'
    },
    input: {
      label: '#D5DBFF'
    },
    layerButtonActive: {
      main: '#5B6CD6',
      contrastText: '#FFFFFF',
    },
    layerButtonBorderActive: {
      main: 'pink',
      contrastText: 'red',
    },
    layerButtonNonActive : {
      main: '#FFFFFF',
      contrastText: '#000000',
    },
    buttonSettings: {
      main: '#FFFFFF',
      contrastText: '#172370',
    },
    mapTypeActive: {
      main: '#000000',
    },
    mapTypeNonActive: {
      main: '#FFFFFF'
    },
    zone: {
      main: '#C75302',
      contrastText: '#000000',
      contrastBackground: '#FFFFFF',
      contrastBorder: '#FFFFFF'
    },
  }
});

export default theme;